import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import mixin from "./mixins";
import config from "./config.json";

import ElementUI from "element-ui";
import "default-passive-events";
import lang from "element-ui/lib/locale/lang/zh-TW";
import locale from "element-ui/lib/locale";
// import VConsole from "vconsole";
// const vConsole = new VConsole()
// export default vConsole

import IntroJs from "intro.js";

// css
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/base.css";
import "bootstrap"; // Import js file
import "bootstrap/dist/css/bootstrap.min.css"; // Import css file
import "@fortawesome/fontawesome-free/css/all.css";
import "intro.js/introjs.css";
import "./styles/app.scss";
import "bootstrap-xxl/dist/css/bootstrap-grid.min.css"; //for xxl grid
import "vue2-animate/dist/vue2-animate.min.css";

import localStorage from "@/utils/localStorage";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/zh-tw";
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(updateLocale);
dayjs.locale("zh-tw");
dayjs.updateLocale("zh-tw", {
  weekStart: 1,
});

import $ from "jquery-ajax";
window.$ = $;

// import NxVet SDK
import NxVet from "./utils/nxvet-sdk/src/sdk";
window.NxVet = NxVet;

// import NxVet V2 SDK
import NxVetV2 from "./utils/nxvet-sdk/src/sdk-v2";
window.NxVetV2 = new NxVetV2({
  hostname: window.location.hostname,
});

// import NxVet Socket SDK
import NxVetSocket from "./utils/nxvet-sdk/src/sdk-socket";
window.NxVetSocket = new NxVetSocket({
  hostname: window.location.hostname,
});

// import NxErp SDK
import NxErp from "./utils/nxerp-sdk/src/sdk";
window.NxErp = NxErp;

// cool lightbox
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

// set element ui lang
locale.use(lang);

Vue.use(ElementUI);

Vue.prototype.$config = config;

Vue.mixin(mixin);

import changePlugin from "./plugins/changePlugin.js";
Vue.use(changePlugin, { store, router, ElementUI });
import lastViewPlugin from "./plugins/lastViewPlugin.js";
Vue.use(lastViewPlugin);
import extensionPlugin from "./plugins/extensionPlugin.js";
Vue.use(extensionPlugin);
import permissionPlugin from "./plugins/permissionPlugin.js";
Vue.use(permissionPlugin, { store });
import customizePlugin from "./plugins/customizePlugin.js";
Vue.use(customizePlugin, { store });
import cachePlugin from "./plugins/cachePlugin.js";
Vue.use(cachePlugin, { store, ElementUI });

import dialogDrag from "./directive/dialogDrag.js";
Vue.directive("nx-dialog-drag", dialogDrag(Vue));

Vue.config.productionTip = false;

if (window !== undefined) {
  // get gtag id
  /*window.gtagId = document
    .querySelector('meta[name="gtag_id"]')
    .getAttribute("content");*/

  // set dayjs
  window.dayjs = dayjs;
  window.storage = localStorage;
  window.storage.init();
  window.introJs = IntroJs;

  window.VueApp = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");

  // debug mode
  if (config.APP_ENV !== "production") {
    window.onerror = function(message, source, lineno, colno, error) {
      console.log("Something Error:", message, source, error);
    };
  }
} else {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

//fix el-select ios bug
let fixElSelect = function () {
	document.querySelectorAll('.el-select[data-is-search="true"]:hover').forEach((v) => {
		let elInput = document.querySelector('.el-select[data-is-search="true"]:hover input[readonly]');
		if (elInput) {
			elInput.readOnly = false;
			elInput.blur();
			elInput.focus();
		}
	});
};
document.addEventListener("focusin", fixElSelect);
document.addEventListener("click", fixElSelect);
document.addEventListener("touchstart", fixElSelect);